// extracted by mini-css-extract-plugin
module.exports = {"menu":"ContextMenu_menu__v8ms0"};